import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLayoutParameters } from '../../hooks/useLayoutParameters';
import FinishView from './View';
import { componerConfiguracion } from '../../store/selectors';

function Finish() {

    const selectViewConfig = useMemo(componerConfiguracion, []);
    const viewParameters = useSelector(state => selectViewConfig(state, 'Finish'));
    const templateRef = useRef(null);
    
    return (
        <FinishView viewParameters={viewParameters} templateRef={templateRef} />
    );
}

export default Finish;